"use client";

import React, { useState, useEffect } from "react";
import { Facebook, Twitter, Linkedin, Instagram, MapPin, Phone, Mail, Clock, Activity } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function Footer() {
  const [time, setTime] = useState<string>("");
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    const updateTime = () => {
      const now = new Date();
      const pstTime = now.toLocaleTimeString("en-GB", {
        timeZone: "Europe/London",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true
      });
      setTime(pstTime);
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);
  const currentYear = new Date().getFullYear();
  const services = [{
    name: "Property Management",
    href: "/LandlordsPage"
  }, {
    name: "Rental Valuations",
    href: "/LandlordsPage"
  }, {
    name: "Residential Lettings",
    href: "/PropertiesPage"
  }, {
    name: "Tenant Services",
    href: "/TenantsPage"
  }];
  const socialLinks = [{
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }, {
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }, {
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }];
  return <section data-section-id="24158" id="footer" className="bg-[#161616] text-zinc-400 py-16 md:py-24 overflow-hidden relative border-t border-zinc-800">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-zinc-700 to-transparent opacity-50" />
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1572105/img/olw_lax_logo.png" alt="LiveAmazing" className="h-7 w-auto object-contain brightness-200" />
            </Link>
            <p className="text-sm font-sans leading-relaxed max-w-xs text-zinc-500">
              LiveAmazing delivers bespoke UK letting and property management solutions. 
              Based in London, we empower landlords with premium asset management and 
              provide tenants with high-quality rental homes.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-white font-serif font-semibold tracking-tight text-lg">Services</h3>
            <ul className="flex flex-col gap-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to={service.href} className="group flex items-center gap-2 text-sm font-sans hover:text-[#FFFF00] transition-colors duration-200">
                    <span className="h-px w-0 bg-[#FFFF00] transition-all duration-300 group-hover:w-3" />
                    {service.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-white font-serif font-semibold tracking-tight text-lg">Contact Hub</h3>
            <ul className="flex flex-col gap-4 text-sm font-sans">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#FFFF00] shrink-0 mt-1" />
                <span>94 Goldhawk Road, W128HD, London<br /><span className="text-xs text-zinc-600" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:eal9xp" data-ast-start="3896" data-ast-end="3969">United Kingdom Head Office</span></span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#FFFF00] shrink-0" />
                <Link to="tel:+442079460000" className="hover:text-white transition-colors">+44 7542683501</Link>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#FFFF00] shrink-0" />
                <Link to="mailto:hello@liveamazing.uk" className="hover:text-white transition-colors">info@liveamazing.uk</Link>
              </li>
            </ul>

            {}
            <div className="mt-2 p-4 rounded-md bg-[#1C1C1C] border border-zinc-800 backdrop-blur-sm">
              <div className="flex items-center gap-2 text-xs text-zinc-500 mb-1 uppercase tracking-widest font-sans font-medium">
                <Clock className="w-3 h-3" />
                Office Time (GMT)
              </div>
              <div className="text-2xl font-mono text-white font-bold tracking-widest">
                {mounted ? time : "--:--:-- --"}
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-white font-serif font-semibold tracking-tight text-lg">Lettings Status</h3>
            
            {}
            <div className="flex flex-col gap-3 p-4 rounded-md bg-[#1C1C1C] border border-zinc-800 backdrop-blur-sm">
              <div className="flex items-center justify-between">
                <span className="text-sm font-sans font-medium text-zinc-300">Listing Feed</span>
                <Activity className="w-4 h-4 text-[#FFFF00]" />
              </div>
              <div className="flex items-center gap-2">
                <span className="relative flex h-2.5 w-2.5">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#FFFF00] opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#FFFF00]"></span>
                </span>
                <span className="text-xs font-mono text-[#FFFF00] uppercase tracking-wider">Active</span>
              </div>
              <div className="h-1 w-full bg-zinc-800 rounded-full overflow-hidden mt-1">
                <div className="h-full bg-[#FFFF00]/50 w-full animate-pulse" />
              </div>
            </div>

            <div className="flex flex-col gap-3 mt-2">
              <span className="text-xs text-zinc-500 uppercase tracking-widest font-sans font-medium">Connect With Us</span>
              <div className="flex gap-2">
                {socialLinks.map((social, i) => <Button key={i} data-index={i} variant="outline" size="icon" className="h-9 w-9 rounded-md border-zinc-800 bg-[#1C1C1C] text-zinc-400 hover:bg-[#FFFF00] hover:text-black hover:border-[#FFFF00] transition-all duration-300 cursor-pointer" asChild>
                    <Link to={social.href} newTab aria-label={social.label}>
                      <social.icon className="w-4 h-4" />
                    </Link>
                  </Button>)}
              </div>
            </div>
          </div>
        </div>

        <Separator className="bg-zinc-800 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs font-sans text-zinc-600">
          <p>&copy; {currentYear} LiveAmazing. All rights reserved. ARLA Propertymark Protected.</p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-zinc-400 transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-zinc-400 transition-colors">Terms of Service</Link>
            <Link to="#" className="hover:text-zinc-400 transition-colors">Sitemap</Link>
          </div>
        </div>
      </div>
    </section>;
}